module.exports = __webpack_public_path__ + "img/check.75bcdab2.svg";